import React from 'react';
import CampaignEditor from './CampaignEditor';

export default function AddCampaign(props) {
    return <CampaignEditor {...props} mode="create"/>;
}
